import axios from "axios";
import {WinForm} from '@/libs'

export class FileService {
	
  static webFileUpload(url: string, data: any, progressFn: string) {
    return new Promise((resolve) => {
      const fd = new FormData();
      Object.keys(data).forEach((item) => {
        fd.append(item, data[item]);
      });
      axios({
        method: 'post',
        url,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: fd,
        onUploadProgress: (evt) => {
          // @ts-ignore
          const progress = parseInt((evt.loaded / evt.total) * 100);
          if (progressFn) {
            WinForm.md.$emit(progressFn, { ...data, progress })
          }
        },
      }).then(res => {
        resolve(res);
      }).catch(err => {
        console.log(err);
        resolve(null);
      })
    })
  }

  /**
   * 获取blob
   * @param url 
   * @returns 
   */
  static getBlob(url: string) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject(null);
            }
            console.log(xhr)
        };
        xhr.onerror = () => {
          reject(new Error(xhr.statusText));
        }
        xhr.send();
    });
  }

  /**
   * 保存blob
   * @param blob 
   * @param filename 
   */
  static saveAs(blob: any, filename: string) {
    // @ts-ignore
    if (window.navigator.msSaveOrOpenBlob) {
      // @ts-ignore
      navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        if (!body) {
          return;
        }
        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);
        
        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
    }
  }

}
